export const fontSizeVariants = {
  'font-size': {
    'base-xs': 'text-base-xs',
    'base-sm': 'text-base-sm',
    'base-md': 'text-base-md',
    'base-mdt': 'text-base-mdt',
    'base-lg': 'text-base-lg',
    'base-lgt': 'text-base-lgt',
    'base-xl': 'text-base-xl',
    'base-xlt': 'text-base-xlt',

    'title-xs': 'text-title-xs',
    'title-sm': 'text-title-sm',
    'title-md': 'text-title-md',
    'title-lg': 'text-title-lg',

    'titles-xs-semibold': 'text-titles-xs-semibold',
    'titles-sm-semibold': 'text-titles-sm-semibold',
    'titles-md-semibold': 'text-titles-md-semibold',
    'titles-lg-semibold': 'text-titles-lg-semibold',
    'titles-xl-semibold': 'text-titles-xl-semibold',
    'titles-2xl-semibold': 'text-titles-2xl-semibold',

    'titles-sm-medium': 'text-titles-sm-medium',
    'titles-md-medium': 'text-titles-md-medium',
    'titles-lg-medium': 'text-titles-lg-medium',
  },
  'font-size-sm': {
    'base-xs': 'sm:text-base-xs',
    'base-sm': 'sm:text-base-sm',
    'base-md': 'sm:text-base-md',
    'base-mdt': 'sm:text-base-mdt',
    'base-lg': 'sm:text-base-lg',
    'base-lgt': 'sm:text-base-lgt',
    'base-xl': 'sm:text-base-xl',
    'base-xlt': 'sm:text-base-xlt',

    'title-xs': 'sm:text-title-xs',
    'title-sm': 'sm:text-title-sm',
    'title-md': 'sm:text-title-md',
    'title-lg': 'sm:text-title-lg',

    'titles-xs-semibold': 'sm:text-titles-xs-semibold',
    'titles-sm-semibold': 'sm:text-titles-sm-semibold',
    'titles-md-semibold': 'sm:text-titles-md-semibold',
    'titles-lg-semibold': 'sm:text-titles-lg-semibold',
    'titles-xl-semibold': 'sm:text-titles-xl-semibold',
    'titles-2xl-semibold': 'sm:text-titles-2xl-semibold',

    'titles-sm-medium': 'sm:text-titles-sm-medium',
    'titles-md-medium': 'sm:text-titles-md-medium',
    'titles-lg-medium': 'sm:text-titles-lg-medium',
  },
  'font-size-md': {
    'base-xs': 'md:text-base-xs',
    'base-sm': 'md:text-base-sm',
    'base-md': 'md:text-base-md',
    'base-mdt': 'md:text-base-mdt',
    'base-lg': 'md:text-base-lg',
    'base-lgt': 'md:text-base-lgt',
    'base-xl': 'md:text-base-xl',
    'base-xlt': 'md:text-base-xlt',

    'title-xs': 'md:text-title-xs',
    'title-sm': 'md:text-title-sm',
    'title-md': 'md:text-title-md',
    'title-lg': 'md:text-title-lg',

    'titles-xs-semibold': 'md:text-titles-xs-semibold',
    'titles-sm-semibold': 'md:text-titles-sm-semibold',
    'titles-md-semibold': 'md:text-titles-md-semibold',
    'titles-lg-semibold': 'md:text-titles-lg-semibold',
    'titles-xl-semibold': 'md:text-titles-xl-semibold',
    'titles-2xl-semibold': 'md:text-titles-2xl-semibold',

    'titles-sm-medium': 'md:text-titles-sm-medium',
    'titles-md-medium': 'md:text-titles-md-medium',
    'titles-lg-medium': 'md:text-titles-lg-medium',
  },
  'font-size-lg': {
    'base-xs': 'lg:text-base-xs',
    'base-sm': 'lg:text-base-sm',
    'base-md': 'lg:text-base-md',
    'base-mdt': 'lg:text-base-mdt',
    'base-lg': 'lg:text-base-lg',
    'base-lgt': 'lg:text-base-lgt',
    'base-xl': 'lg:text-base-xl',
    'base-xlt': 'lg:text-base-xlt',

    'title-xs': 'lg:text-title-xs',
    'title-sm': 'lg:text-title-sm',
    'title-md': 'lg:text-title-md',
    'title-lg': 'lg:text-title-lg',

    'titles-xs-semibold': 'lg:text-titles-xs-semibold',
    'titles-sm-semibold': 'lg:text-titles-sm-semibold',
    'titles-md-semibold': 'lg:text-titles-md-semibold',
    'titles-lg-semibold': 'lg:text-titles-lg-semibold',
    'titles-xl-semibold': 'lg:text-titles-xl-semibold',
    'titles-2xl-semibold': 'lg:text-titles-2xl-semibold',

    'titles-sm-medium': 'lg:text-titles-sm-medium',
    'titles-md-medium': 'lg:text-titles-md-medium',
    'titles-lg-medium': 'lg:text-titles-lg-medium',
  },
  'font-size-xl': {
    'base-xs': 'xl:text-base-xs',
    'base-sm': 'xl:text-base-sm',
    'base-md': 'xl:text-base-md',
    'base-mdt': 'xl:text-base-mdt',
    'base-lg': 'xl:text-base-lg',
    'base-lgt': 'xl:text-base-lgt',
    'base-xl': 'xl:text-base-xl',
    'base-xlt': 'xl:text-base-xlt',

    'title-xs': 'xl:text-title-xs',
    'title-sm': 'xl:text-title-sm',
    'title-md': 'xl:text-title-md',
    'title-lg': 'xl:text-title-lg',

    'titles-xs-semibold': 'xl:text-titles-xs-semibold',
    'titles-sm-semibold': 'xl:text-titles-sm-semibold',
    'titles-md-semibold': 'xl:text-titles-md-semibold',
    'titles-lg-semibold': 'xl:text-titles-lg-semibold',
    'titles-xl-semibold': 'xl:text-titles-xl-semibold',
    'titles-2xl-semibold': 'xl:text-titles-2xl-semibold',

    'titles-sm-medium': 'xl:text-titles-sm-medium',
    'titles-md-medium': 'xl:text-titles-md-medium',
    'titles-lg-medium': 'xl:text-titles-lg-medium',
  },
}
